import { Heading, Stack } from '@react/chakra';

import type { JSX } from 'react';
import type { IPostVMProps } from '@data/view-models';

import { Link } from '~/components';

interface ISeriesTableOfContentsProps {
  data: IPostVMProps;
}

export function SeriesTableOfContents({
  data,
}: ISeriesTableOfContentsProps): JSX.Element {
  const { seriesPost } = data;
  const { series, chapterSlug } = seriesPost || {};
  const { posts = [] } = series || {};

  return (
    <Stack p={6} gap={6} borderRadius='8px' bgColor='green.700' mb={20}>
      <Heading size='2xl'>Contents</Heading>
      <Stack pl={4} gap={4}>
        {posts.map((post) => {
          const { slug, title, chapter } = post;
          const isCurrentPost = slug === chapterSlug;

          const headingElement = (
            <Heading
              size='xl'
              key={slug}
              color={isCurrentPost ? 'gray.300' : 'white'}
              cursor={isCurrentPost ? 'default' : 'pointer'}
              _hover={{
                color: isCurrentPost ? 'gray.300' : 'gray.200',
              }}
            >
              Chapter {chapter}: {title}
            </Heading>
          );

          if (isCurrentPost) {
            return headingElement;
          }

          return (
            <Link key={slug} noUnderline href={`/posts/${slug}`}>
              {headingElement}
            </Link>
          );
        })}
      </Stack>
    </Stack>
  );
}
